import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { addUserEnteredMedicationToInquiry } from '@api/inquiries';
import {
  createNewUserEnteredMedication,
  editUserEnteredMedication,
  getUserEnteredMedicationDetails,
  markMedicationAsViewed,
  submitMedicationNeedsInfoForm,
} from '@api/medications';
import { IAddMedicationToInquiryPayload } from '@interfaces/inquiries';
import {
  ICreateNewMedicationResponse,
  ISubmitMedicationNeedsInfoFormPayload,
  IUserEnteredMedication,
  IUserEnteredMedicationData,
} from '@interfaces/medications';

export const handleCreateNewUserEnteredMedication = createAsyncThunk<
  AxiosResponse<ICreateNewMedicationResponse>,
  IUserEnteredMedicationData
>('createNewUserEnteredMedication', createNewUserEnteredMedication);

export const handleGetUserEnteredMedicationDetails = createAsyncThunk<
  AxiosResponse<IUserEnteredMedication>,
  { id: number }
>('getUserEnteredMedicationDetails', ({ id }) => getUserEnteredMedicationDetails(id));

export const handleEditUserEnteredMedication = createAsyncThunk<
  AxiosResponse<IUserEnteredMedication>,
  IUserEnteredMedication
>('editUserEnteredMedication', editUserEnteredMedication);

export const handleAddUserEnteredMedicationToInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAddMedicationToInquiryPayload
>('addUserEnteredMedicationToInquiry', addUserEnteredMedicationToInquiry);

export const handleSubmitMedicationNeedsInfoForm = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  ISubmitMedicationNeedsInfoFormPayload
>('submitMedicationNeedsInfoForm', submitMedicationNeedsInfoForm);

export const handleMarkMedicationResponseAsViewed = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('markMedicationAsViewed', markMedicationAsViewed);
